import { render, staticRenderFns } from "./UnassignedOrder.vue?vue&type=template&id=0062770a&scoped=true"
import script from "./UnassignedOrder.vue?vue&type=script&lang=js"
export * from "./UnassignedOrder.vue?vue&type=script&lang=js"
import style0 from "./UnassignedOrder.vue?vue&type=style&index=0&id=0062770a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0062770a",
  null
  
)

export default component.exports